import { render } from "./HotelSearch.vue?vue&type=template&id=be680c1c&scoped=true"
import script from "./HotelSearch.vue?vue&type=script&lang=js"
export * from "./HotelSearch.vue?vue&type=script&lang=js"

import "./HotelSearch.vue?vue&type=style&index=0&id=be680c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be680c1c"]])

export default __exports__